import { Grid, Typography } from '@cmg/design-system';
import type { FC } from 'react';

export type DescriptionListHeadingProps = {
  readonly title: string;
};

export const DescriptionListHeading: FC<DescriptionListHeadingProps> = ({ title }) => {
  return (
    <Grid item xs={12} paddingY={2}>
      <Typography variant="h4">{title}</Typography>
    </Grid>
  );
};
